import { fusionarDocumentos } from "./fusionDocumentos";

/**
 * Deja creados en blanco los documentos que le corresponden a la persona en
 * cuanto elige con que perfil se presenta.
 *
 * Hasta ahora, si alguien no subia nada en la documentacion administrativa
 * —cosa que se permite, porque es subsanable— la postulacion quedaba con la
 * columna vacia. Despues no habia forma de saber que documentos se le
 * pidieron, ni al profesional que verifica ni al propio participante.
 *
 * Sembrarlos en blanco deja constancia de lo que se exigia, aunque no se haya
 * subido nada.
 */

/** Los documentos que aplican a ese perfil, listos y sin archivo. */
export const documentosEnBlanco = (
  definiciones: any[],
  tipoPersona: number
): any[] => {
  const lista = Array.isArray(definiciones) ? definiciones : [];

  return lista
    .filter((documento) => documento && documento.tipo_persona === tipoPersona)
    .map((documento) => ({
      id: documento.id,
      idconvocatoria: documento.idconvocatoria,
      descripcion: documento.descripcion,
      obligatorio: documento.obligatorio,
      subsanable: documento.subsanable,
      tipo_documento_id: documento.tipo_documento_id,
      tipo_documento: documento.tipo_documento,
      tipo_persona: documento.tipo_persona,
      url_documento: documento.url_documento,
      url_participante: "",
      fecha_firma: "",
      participantes: [],
    }));
};

/** Un documento sembrado y nunca tocado: no hay nada que perder al quitarlo. */
const estaIntacto = (documento: any): boolean =>
  !documento?.url_participante &&
  !documento?.fecha_firma &&
  !documento?.escrito &&
  !documento?.url_video &&
  (documento?.participantes?.length ?? 0) === 0;

/**
 * Lo que deberia quedar guardado: lo sembrado, pero conservando cualquier
 * archivo que ya estuviera cargado.
 *
 * Quien cambia de perfil —de persona juridica a grupo conformado, por
 * ejemplo— arrastraba los documentos del perfil anterior, porque la fusion
 * conserva lo que solo esta guardado. Quedaban dos cedulas, tres RUT y una
 * carta de conformacion al lado de una de representante legal.
 *
 * Los del perfil anterior se sueltan solo si estan intactos. Si alguien
 * alcanzo a cargar algo bajo el otro perfil se conserva: borrarlo en
 * silencio seria peor que dejarlo de mas, y el listado ya filtra por perfil.
 */
export const documentosSembrados = (
  yaGuardados: any[],
  enBlanco: any[],
  tipoPersona?: number
): any[] => {
  const actuales = Array.isArray(yaGuardados) ? yaGuardados : [];

  const conservables =
    tipoPersona === undefined
      ? actuales
      : actuales.filter(
          (documento: any) =>
            documento?.tipo_persona === undefined ||
            documento?.tipo_persona === null ||
            Number(documento.tipo_persona) === Number(tipoPersona) ||
            !estaIntacto(documento)
        );

  return fusionarDocumentos(conservables, enBlanco);
};

/**
 * Si no cambia nada, no se escribe. Sembrar tiene que poder repetirse sin
 * consecuencias, porque se dispara cada vez que se elige el perfil.
 */
export const hayQueSembrar = (yaGuardados: any[], resultado: any[]): boolean => {
  const actuales = Array.isArray(yaGuardados) ? yaGuardados : [];
  if (actuales.length !== resultado.length) return true;

  const porId = new Map(actuales.map((documento) => [String(documento?.id), documento]));
  return resultado.some((documento) => !porId.has(String(documento?.id)));
};
